import React, {useState, useEffect} from "react";
import {Images} from "./index";


function NoData({type, title}) {

    return <div className="text-center" style={{marginTop: 120}}>
            <Images height={200} src={require('../../images/info.png')} />
            {/*<div>
                <h5 className="text-white text-center">{title ?? `No ${type ?? ''} data to display.`}</h5>
            </div>*/}
        </div>

}

export default NoData;